/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';

export default (visualizationType :any, placement :any) :boolean => {

    const { requirements } = visualizationType;
    if (!requirements) {
        // no requirements means no violations
        return true;
    }

    const { fields } = requirements;
    if (!fields) {
        // no fields from requirements means no violations
        return true;
    }

    let
        rowCheckPassed = false,
        columnCheckPassed = false;

    if ((fields.inRow || _.isUndefined(fields.inRow)) || placement.row.indexOf('f') === -1) {
        rowCheckPassed = true;
    }

    if ((fields.inColumn || _.isUndefined(fields.inColumn)) || placement.column.indexOf('f') === -1) {
        columnCheckPassed = true;
    }

    return rowCheckPassed && columnCheckPassed;
};
